import { UserRoles } from '@/_helpers/interfaces';
import type { RolesDashboardStatistics } from '@/_helpers/interfaces/dashboards/roles-dashboard-statistics.interface';
import { useUserStore } from '@/stores/user.store';
import { useI18n } from 'vue-i18n';

interface RolesDashboardCount {
  key: string;
  value: number;
  type: 'number' | 'currency';
}

export const useRolesDashboardCounts = () => {
  const { currentUser } = useUserStore();
  const { t } = useI18n();
  const getRolesStatisticsCounts = (statisticsData: RolesDashboardStatistics) => {
    const statisticsCounts: RolesDashboardCount[] = [];

    currentUser?.user_role.forEach(role => {
      switch (role) {
        case UserRoles.PURCHASER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_orders'),
            value: statisticsData.order_counts.total_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_orders'),
            value: statisticsData.order_counts.pending_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_orders'),
            value: statisticsData.order_counts.approved_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_orders'),
            value: statisticsData.order_counts.rejected_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.total_amount_spent'),
            value: statisticsData.amounts.total_amount_spent,
            type: 'currency',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.total_max_limit'),
            value: statisticsData.amounts.total_max_limit,
            type: 'currency',
          });
          break;

        case UserRoles.ORDER_CLEARER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_orders'),
            value: statisticsData.order_counts.total_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_orders'),
            value: statisticsData.order_counts.pending_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_orders'),
            value: statisticsData.order_counts.approved_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_orders'),
            value: statisticsData.order_counts.rejected_orders,
            type: 'number',
          });
          break;

        case UserRoles.PAYER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_payments'),
            value: statisticsData.payment_counts.total_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_payments'),
            value: statisticsData.payment_counts.pending_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_payments'),
            value: statisticsData.payment_counts.approved_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_payments'),
            value: statisticsData.payment_counts.rejected_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.total_max_limit'),
            value: statisticsData.amounts.total_max_limit,
            type: 'currency',
          });
          break;

        case UserRoles.PAYMENT_CLEARER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_payments'),
            value: statisticsData.payment_counts.total_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_payments'),
            value: statisticsData.payment_counts.pending_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_payments'),
            value: statisticsData.payment_counts.approved_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_payments'),
            value: statisticsData.payment_counts.rejected_payments,
            type: 'number',
          });
          break;

        case UserRoles.APPROVER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_payments'),
            value: statisticsData.payment_counts.total_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_payments'),
            value: statisticsData.payment_counts.pending_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_payments'),
            value: statisticsData.payment_counts.approved_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_payments'),
            value: statisticsData.payment_counts.rejected_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.total_orders'),
            value: statisticsData.order_counts.total_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_orders'),
            value: statisticsData.order_counts.pending_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_orders'),
            value: statisticsData.order_counts.approved_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_orders'),
            value: statisticsData.order_counts.rejected_orders,
            type: 'number',
          });
          break;

        case UserRoles.VIEWER:
          statisticsCounts.push({
            key: t('dashboard.titles.total_payments'),
            value: statisticsData.payment_counts.total_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_payments'),
            value: statisticsData.payment_counts.pending_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_payments'),
            value: statisticsData.payment_counts.approved_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_payments'),
            value: statisticsData.payment_counts.rejected_payments,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.total_orders'),
            value: statisticsData.order_counts.total_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.pending_orders'),
            value: statisticsData.order_counts.pending_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.approved_orders'),
            value: statisticsData.order_counts.approved_orders,
            type: 'number',
          });
          statisticsCounts.push({
            key: t('dashboard.titles.rejected_orders'),
            value: statisticsData.order_counts.rejected_orders,
            type: 'number',
          });
          break;
      }
    });

    return statisticsCounts;
  };

  return { getRolesStatisticsCounts };
};
